import { timelineHomeMarkerCenterX } from "@/lib/timeline/scene/SceneMotion/motion";

/** Shift baked board X coords when the stage width differs from build reference. */
export function boardViewportXDelta(
  viewportWidth: number,
  referenceViewportWidth: number,
): number {
  return (
    timelineHomeMarkerCenterX(viewportWidth)
    - timelineHomeMarkerCenterX(referenceViewportWidth)
  );
}
